import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { AiFillLock } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
const AllData = gql`
  query {
    getallloads {
      _id
      From_City
      To_City
      Vehicle_Type
      Weight_Category
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Landmark
      Unloading_Name
      Unloading_City
      Unloading_Area
      Loading_Scope
      Loading_Time
      Loading_State
      Loading_Pincode
      Loading_Name
      Loading_Landmark
      Loading_Date
      Load_Manager
      Loading_Area
      Loading_By
      Loading_City
      Total_Weight
      Target_Price
      Rate_per
      Over_Dimension_Cargo
      Payment_Type
      Notes
      No_Of_Vehicels_Required
      Material_Image_1
      Material_Image_2
      Material_Image_3
      Material_Dimension
      Material_Insurence
      Material_Category
      Load_Live_Duration
      Expected_Price
      Dangerous_Goods
      Exact_Content
      Auction_Time
      Auction_Date
      createdAt
      updatedAt
      is_Audit
    }
  }
`;

const RequestApproval = () => {
  const { loading, error, data, refetch, fetchMore } = useQuery(AllData, {
    fetchPolicy: "network-only",
  });
  const [formdata, setformdata] = useState(data ? data.GetLoadsOnRequestedData : []);
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const [isFetching, setIsFetching] = useState(false);
  let Refetch = useSelector((store) => store.FormFieldData.refresh);
  const dispatch = useDispatch();
  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  useEffect(() => {
    if (Refetch) {
      refetch();
      dispatch({ type: "Refetch", payload: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Refetch]);

  useEffect(() => {
    refetch({ Status: Tab });
    if (Refetch) {
      dispatch({ type: "Refetch", payload: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Refetch, Tab]);

  useEffect(() => {
    let arr = data?.getallloads.map((e) => {
      let obj = { ...e };
      delete obj.__typename;
      delete obj.is_Audit;
      return {
        A: e.is_Audit ? <AiFillLock /> : "",
        ...obj,
        createdAt: IsoToDateTime(e.createdAt),
        updatedAt: IsoToDateTime(e.updatedAt),
      };
    });

    setformdata(arr);
  }, [data]);

  useEffect(() => {
    if (!loading && isFetching) {
      loadMore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isFetching]);
  const loadMore = () => {
    fetchMore({
      variables: {
        offset: formdata.length,
      },
    });
    setIsFetching(false);
  };

  return (
    <>
      <HeaderDiv title={"Loads Data"} />
      {loading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <LoadTable title="Loads Data" data={formdata} loading={loading} error={error} />
      )}
    </>
  );
};

export default RequestApproval;
